import React from "react";

const Logo = ({ size = "md" }) => {
  const sizes = {
    sm: { script: "text-3xl", dental: "text-[10px]" },
    md: { script: "text-4xl md:text-5xl", dental: "text-xs" },
    lg: { script: "text-5xl md:text-6xl", dental: "text-sm" },
  };
  const s = sizes[size];
  return (
    <div className="flex flex-col items-center leading-none select-none">
      <span
        className={`font-script ${s.script} gold-gradient-text block p-2`}
        style={{ textShadow: "0 0 12px rgba(200,168,120,0.25)", lineHeight: "1.4" }}
      >
        Galleria Dental
      </span>
    </div>
  );
};

export default Logo;
